// extracted by mini-css-extract-plugin
export default {"root":"CalendarRegularEvent_root__98Lao","hours":"CalendarRegularEvent_hours__vXcmH","desc":"CalendarRegularEvent_desc__-T-+B"};